/** Weniger als drei Zeilen wären keine Liste mehr; darunter wird nicht gekürzt. */
export const SUMMARY_LIST_MIN_VISIBLE_ITEMS = 3;

/**
 * Wie viele Zeilen in eine Höhe passen, ohne eine anzuschneiden — mindestens
 * `SUMMARY_LIST_MIN_VISIBLE_ITEMS`, höchstens die Anzahl vorhandener Einträge.
 * Ohne gemessene Zeilenhöhe (erster Aufbau) gilt die Untergrenze.
 */
export function summaryListVisibleCount(containerHeight: number, rowHeight: number, itemCount: number): number {
  if (itemCount <= SUMMARY_LIST_MIN_VISIBLE_ITEMS) return itemCount;
  if (rowHeight <= 0 || containerHeight <= 0) return SUMMARY_LIST_MIN_VISIBLE_ITEMS;
  const fitting = Math.floor(containerHeight / rowHeight);
  return Math.min(itemCount, Math.max(SUMMARY_LIST_MIN_VISIBLE_ITEMS, fitting));
}
